export default __webpack_public_path__ + "static/media/icon-user.bdd8adf4.webp";